export default {
  header: 'Riepilogo ordine',
  buttons: {
    checkout: 'Pagamento sicuro',
    continue: 'Continua',
    add_products: '+ Aggiungi prodotti',
    add_items: '+ Aggiungi altri articoli',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Il carrello è vuoto <br/> Aggiungi articoli per iniziare',
  },
  promo_code_banner: {
    single_use: '{{discount}} di sconto - {{code}}',
    multi_use: '{{discount}} di sconto su {{count}} ordini - {{code}}',
    redeem: 'RISCATTA',
    redeemed: 'RISCATTATO',
  },
  upsell: {
    title: 'Altri ordinano anche',
  },
  rewards: {
    title: 'Paga con i punti',
    description: '<highlight>Accedi</highlight> per pagare con i punti',
  },
  already_member: 'Sei già membro?',
  sign_in: 'Accedi',
  summary: {
    subtotal: 'Subtotale',
    delivery: 'Consegna',
    pickup: 'Ritiro',
    total: 'Totale',
    free: 'Gratis',
  },
  footer: {
    member_earning: '+{{points}} pt dopo il pagamento · {{balance}} pt di saldo',
    guest_earning: 'Registrati per guadagnare punti su questo ordine',
  },
};
